<div class="relative">
  <!-- Bouton notifications -->
  <button (click)="toggleDropdown()"
    class="relative p-2 text-gray-500 hover:text-gray-700 transition-colors rounded-lg hover:bg-gray-100">
    <icon-notification-bell [size]="20" />

    <!-- Badge count -->
    @if (unreadCount() > 0) {
    <span
      class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 font-medium">
      {{ unreadCount() > 99 ? '99+' : unreadCount() }}
    </span>
    }
  </button>

  <!-- Dropdown -->
  @if (isOpen) {
  <div
    class="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-50 max-h-96 overflow-hidden">
    <!-- Header -->
    <div class="px-4 py-3 border-b border-gray-200 flex items-center justify-between">
      <h3 class="text-gray-900">Notifications</h3>
      <div class="flex items-center gap-2">
        @if (unreadCount() > 0) {
        <button (click)="markAllAsRead()" class="text-xs text-blue-600 hover:text-blue-700">
          Tout marquer comme lu
        </button>
        }
        <button (click)="refresh()" [disabled]="loading()"
          class="p-1 text-gray-400 hover:text-gray-600 transition-colors">
          <icon-clock [size]="14" [class.animate-spin]="loading()" />
        </button>
      </div>
    </div>

    <!-- Liste des notifications -->
    <div class="max-h-64 overflow-y-auto" data-lenis-prevent>
      @if (loading() && notifications().length === 0) {
      <div class="p-4 space-y-3">
        @for (item of [1,2,3]; track item) {
        <div class="animate-pulse">
          <div class="flex space-x-3">
            <div class="w-8 h-8 bg-gray-200 rounded-full"></div>
            <div class="flex-1 space-y-2">
              <div class="h-4 bg-gray-200 rounded w-3/4"></div>
              <div class="h-3 bg-gray-200 rounded w-1/2"></div>
            </div>
          </div>
        </div>
        }
      </div>
      } @else if (notifications().length === 0) {
      <div class="p-8 text-center">
        <icon-notification-bell [size]="32" class="text-gray-300 mx-auto mb-2" />
        <p class="text-gray-500 text-sm">Aucune notification</p>
      </div>
      } @else {
      @for (notification of notifications(); track notification.id) {
      <div class="px-4 py-3 hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-b-0"
        [class.bg-blue-50]="!notification.isRead">
        <div class="flex items-start gap-3">
          <!-- Icône de type -->
          <div class="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
            [ngClass]="getNotificationIconClass(notification.type)">
            <span class="text-sm">{{ getNotificationIcon(notification.type) }}</span>
          </div>

          <!-- Contenu -->
          <div class="flex-1 min-w-0">
            <div class="flex items-start justify-between">
              <div class="flex-1">
                <h4 class="text-sm font-medium text-gray-900 mb-1">
                  {{ notification.title }}
                </h4>
                <p class="text-sm text-gray-600 mb-2 line-clamp-2">
                  {{ notification.message }}
                </p>
                <p class="text-xs text-gray-400">
                  {{ notification.createdAt | date:'dd/MM/yyyy HH:mm' }}
                </p>
              </div>

              <!-- Actions -->
              <div class="flex items-center gap-1 ml-2">
                @if (notification.isRead) {
                <button (click)="markAsUnread(notification.id)"
                  class="p-1 text-gray-400 hover:text-gray-600 transition-colors" title="Marquer comme non lu">
                  <icon-clock [size]="12" />
                </button>
                } @else {
                <button (click)="markAsRead(notification.id)"
                  class="p-1 text-blue-500 hover:text-main-600 transition-colors" title="Marquer comme lu">
                  <icon-check [size]="12" />
                </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      }
      }
    </div>

    <!-- Footer -->
    @if (notifications().length > 5) {
    <div class="px-4 py-3 border-t border-gray-200 text-center">
      <button class="text-sm text-main-600 hover:text-main-700 font-medium">
        Voir toutes les notifications
      </button>
    </div>
    }
  </div>
  }

  <!-- Overlay pour fermer -->
  @if (isOpen) {
  <div class="fixed inset-0 z-40" (click)="closeDropdown()">
  </div>
  }
</div>